/**
 * 再入荷リクエスト → Shopify App Proxy (/apps/zeta2/api.php) POST（nZETAapp）
 *
 * デバッグ:
 *   - URL に ?zeta_debug_restock=1
 *   - localStorage.setItem('zetaRestockDebug','1')
 *   - window.ZetaRestock.debug = true
 */
(function () {
  'use strict';

  function cfg() {
    return window.ZetaRestock || {};
  }

  function resolveZetaProxyUrl(url) {
    if (!url || typeof url !== 'string') {
      return url;
    }
    var u = url.trim();
    if (/^https?:\/\//i.test(u)) {
      return u;
    }
    var origin = window.location.origin || '';
    if (!origin) {
      return u;
    }
    return u.charAt(0) === '/' ? origin + u : origin + '/' + u.replace(/^\.\//, '');
  }

  function debugEnabled() {
    try {
      if (cfg().debug) {
        return true;
      }
      if (/[?&]zeta_debug_restock=1(?:&|$)/.test(String(window.location.search || ''))) {
        return true;
      }
      if (window.localStorage && localStorage.getItem('zetaRestockDebug') === '1') {
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function log() {
    if (debugEnabled() && typeof console !== 'undefined' && console.log) {
      var a = ['[ZetaRestock]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, a);
    }
  }

  function warn() {
    if (typeof console !== 'undefined' && console.warn) {
      var a = ['[ZetaRestock]'].concat(Array.prototype.slice.call(arguments));
      console.warn.apply(console, a);
    }
  }

  function requestLabel() {
    var c = cfg();
    return (c.strings && c.strings.request) ? c.strings.request : '再入荷リクエスト';
  }

  function requestedLabel() {
    var c = cfg();
    return (c.strings && c.strings.requested) ? c.strings.requested : '再入荷リクエスト済み';
  }

  function ensureRequestedIds() {
    var c = cfg();
    if (!Array.isArray(c.requestedVariantIds)) {
      c.requestedVariantIds = [];
    }
    return c.requestedVariantIds;
  }

  function isRequested(variantId) {
    var id = String(variantId || '');
    if (!id) return false;
    var ids = ensureRequestedIds();
    for (var i = 0; i < ids.length; i++) {
      if (String(ids[i]) === id) return true;
    }
    return false;
  }

  function markRequested(variantId) {
    var id = String(variantId || '');
    if (!id || isRequested(id)) return;
    ensureRequestedIds().push(id);
  }

  function unmarkRequested(variantId) {
    var id = String(variantId || '');
    if (!id) return;
    var ids = ensureRequestedIds();
    var next = [];
    for (var i = 0; i < ids.length; i++) {
      if (String(ids[i]) !== id) next.push(ids[i]);
    }
    cfg().requestedVariantIds = next;
    refreshAllButtons(document);
  }

  function applyButtonState(btn) {
    if (!btn) return;
    var done = isRequested(btn.getAttribute('data-variant-id'));
    var label = done ? requestedLabel() : requestLabel();
    // ATC と同様に span で包む（Safari の flex 中央ずれ対策）
    var span = btn.querySelector('span');
    if (!span) {
      btn.textContent = '';
      span = document.createElement('span');
      btn.appendChild(span);
    }
    span.textContent = label;
    btn.setAttribute('aria-label', label);
    btn.classList.toggle('is-requested', done);
    if (done) {
      btn.setAttribute('data-restock-done', 'true');
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.removeAttribute('data-restock-done');
      btn.removeAttribute('disabled');
    }
    var wrap = btn.closest('.ProductForm__Restock');
    var removeBtn = wrap && wrap.querySelector('[data-restock-remove]');
    if (removeBtn) {
      removeBtn.setAttribute('data-variant-id', String(btn.getAttribute('data-variant-id') || ''));
      if (done) {
        removeBtn.hidden = false;
        removeBtn.disabled = false;
      } else {
        removeBtn.hidden = true;
      }
    }
  }

  function refreshAllButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-restock-button]');
    for (var i = 0; i < buttons.length; i++) {
      applyButtonState(buttons[i]);
    }
  }

  function parseResponseJson(text) {
    var t = String(text || '').replace(/^\uFEFF/, '').trim();
    if (!t) {
      return { __parseError: 'empty_body' };
    }
    try {
      return JSON.parse(t);
    } catch (e1) {
      var start = t.indexOf('{');
      var end = t.lastIndexOf('}');
      if (start !== -1 && end > start) {
        try {
          return JSON.parse(t.slice(start, end + 1));
        } catch (e2) {
          return { __parseError: 'invalid_json', __snippet: t.slice(0, 280) };
        }
      }
      return { __parseError: 'invalid_json', __snippet: t.slice(0, 280) };
    }
  }

  function detectDevice() {
    var ua = navigator.userAgent || '';
    if (/Mobile|Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
      return 'mobile';
    }
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return 'mobile';
    }
    return 'desktop';
  }

  function syncRestockVariant(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) {
      return;
    }
    var root =
      event.target && event.target.closest && event.target.closest('[data-section-type="product"]');
    if (!root) {
      log('variant:changed: no [data-section-type=product] ancestor');
      return;
    }
    var btn = root.querySelector('[data-restock-button]');
    if (btn) {
      btn.setAttribute('data-variant-id', String(variant.id));
      applyButtonState(btn);
      log('variant:changed → data-variant-id=', variant.id, 'requested=', isRequested(variant.id));
    }
  }

  function postRestockAdd(productId, productHandle, variantId) {
    var c = cfg();
    var rawUrl = c.apiUrl;
    if (!rawUrl) {
      return Promise.reject(new Error('no_api'));
    }
    var url = resolveZetaProxyUrl(rawUrl);
    var body = {
      action: 'restock_add',
      product_id: productId,
      product_handle: productHandle,
      variant_id: variantId,
      device: detectDevice()
    };
    log('POST', url, body);
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  function postRestockRemove(variantId) {
    var c = cfg();
    var rawUrl = c.apiUrl;
    if (!rawUrl) {
      return Promise.reject(new Error('no_api'));
    }
    var url = resolveZetaProxyUrl(rawUrl);
    var body = {
      action: 'restock_remove',
      variant_id: variantId
    };
    log('POST', url, body);
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  function showFeedback(btn, message, isError) {
    var wrap = btn.closest('.ProductForm__Restock');
    if (!wrap) {
      warn('showFeedback: .ProductForm__Restock not found');
      return;
    }
    var el = wrap.querySelector('[data-restock-feedback]');
    if (!el) {
      warn('showFeedback: [data-restock-feedback] missing');
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('ProductForm__RestockFeedback--error', !!isError);
    clearTimeout(el._zetaHide);
    el._zetaHide = setTimeout(function () {
      el.hidden = true;
    }, 8000);
    log('feedback:', message, isError ? '(error)' : '(ok)');
  }

  async function onRestockRemoveClick(ev) {
    var removeBtn = ev.target.closest && ev.target.closest('[data-restock-remove]');
    if (!removeBtn || removeBtn.hidden || removeBtn.disabled) {
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();

    var wrap = removeBtn.closest('.ProductForm__Restock');
    var btn = wrap && wrap.querySelector('[data-restock-button]');
    var c = cfg();
    var variantId = parseInt(
      (removeBtn.getAttribute('data-variant-id') || (btn && btn.getAttribute('data-variant-id')) || '0'),
      10
    );

    log('remove click', { variantId: variantId, customerLoggedIn: c.customerLoggedIn });

    if (!c.apiUrl) {
      warn('window.ZetaRestock.apiUrl が空です。');
      return;
    }
    if (!c.customerLoggedIn) {
      var loginMsg = (c.strings && c.strings.loginRequired) ? c.strings.loginRequired : 'Login required';
      window.alert(loginMsg);
      return;
    }
    if (variantId <= 0) {
      return;
    }

    removeBtn.disabled = true;
    try {
      var res = await postRestockRemove(variantId);
      var text = await res.clone().text();
      log('remove response status=', res.status, 'body=', text);
      var data = parseResponseJson(text);

      if (!res.ok) {
        if (!data.__parseError && data.error) {
          var ek = data.error;
          var msg2 = ek === 'login_required' && c.strings && c.strings.loginRequired ? c.strings.loginRequired : ek;
          throw new Error(msg2 || 'HTTP ' + res.status);
        }
        var hint = data.__snippet || String(text || '').replace(/\s+/g, ' ').trim().slice(0, 160);
        throw new Error('HTTP ' + res.status + (hint ? ': ' + hint : ''));
      }
      if (data.__parseError) {
        throw new Error(data.__parseError + (data.__snippet ? ': ' + data.__snippet : ''));
      }
      if (data.ok !== true && data.ok !== 'true') {
        throw new Error(data.error ? String(data.error) : 'unexpected_response');
      }

      // removed:false（既に無い）でも UI は未リクエストに揃える
      unmarkRequested(variantId);
      if (btn) {
        applyButtonState(btn);
        var okMsg = (c.strings && c.strings.removed) ? c.strings.removed : 'Removed';
        showFeedback(btn, okMsg, false);
      }
    } catch (err) {
      warn(err);
      var prefix = c.strings && c.strings.error ? c.strings.error + ': ' : '';
      if (btn) {
        showFeedback(btn, prefix + err.message, true);
      }
      removeBtn.disabled = false;
    }
  }

  async function onRestockClick(ev) {
    var btn = ev.target.closest && ev.target.closest('[data-restock-button]');
    if (!btn) {
      return;
    }
    ev.preventDefault();

    var c = cfg();
    log('click', {
      apiUrl: c.apiUrl,
      customerLoggedIn: c.customerLoggedIn,
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id')
    });

    if (!c.apiUrl) {
      warn('window.ZetaRestock.apiUrl が空です。商品ページで読み込まれているか確認してください。');
      return;
    }

    if (!c.customerLoggedIn) {
      var loginMsg = (c.strings && c.strings.loginRequired) ? c.strings.loginRequired : 'Login required';
      warn('未ログイン:', loginMsg);
      window.alert(loginMsg);
      return;
    }

    var productId = parseInt(btn.getAttribute('data-product-id') || '0', 10);
    var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    var productHandle = (btn.getAttribute('data-product-handle') || '').trim();
    if (productId <= 0 || variantId <= 0 || !productHandle) {
      var badMsg = (c.strings && c.strings.badRequest) ? c.strings.badRequest : 'Invalid product';
      warn('パラメータ不正:', { productId: productId, variantId: variantId, productHandle: productHandle });
      window.alert(badMsg);
      return;
    }

    if (isRequested(variantId) || btn.getAttribute('data-restock-done') === 'true') {
      applyButtonState(btn);
      return;
    }

    if (btn.disabled) {
      return;
    }
    btn.disabled = true;
    try {
      var res = await postRestockAdd(productId, productHandle, variantId);
      var text = await res.clone().text();
      log('response status=', res.status, 'body=', text);

      var data = parseResponseJson(text);

      if (!res.ok) {
        if (!data.__parseError && data.error) {
          var ek = data.error;
          var msg2 = ek === 'login_required' && c.strings && c.strings.loginRequired ? c.strings.loginRequired : ek;
          throw new Error(msg2 || 'HTTP ' + res.status);
        }
        var hint = data.__snippet || String(text || '').replace(/\s+/g, ' ').trim().slice(0, 160);
        throw new Error('HTTP ' + res.status + (hint ? ': ' + hint : ''));
      }

      if (data.__parseError) {
        warn('response parse:', data.__parseError, data.__snippet || text);
        throw new Error(data.__parseError + (data.__snippet ? ': ' + data.__snippet : ''));
      }

      if (data.ok === true || data.ok === 'true') {
        markRequested(variantId);
        applyButtonState(btn);
        var okMsg;
        if (data.duplicate === true || data.duplicate === 'true') {
          okMsg = (c.strings && c.strings.duplicate) ? c.strings.duplicate : 'Already registered';
        } else {
          okMsg = (c.strings && c.strings.submitted) ? c.strings.submitted : 'Submitted';
        }
        showFeedback(btn, okMsg, false);
      } else if (data.error) {
        throw new Error(String(data.error));
      } else {
        warn('res.ok but data.ok is falsy', data);
        var snippet = String(text || '').replace(/\s+/g, ' ').trim().slice(0, 160);
        throw new Error('unexpected_response: ' + (snippet || '(empty)'));
      }
    } catch (err) {
      warn(err);
      var prefix = c.strings && c.strings.error ? c.strings.error + ': ' : '';
      var line = prefix + err.message;
      showFeedback(btn, line, true);
      applyButtonState(btn);
    } finally {
      if (!isRequested(variantId)) {
        btn.disabled = false;
      }
    }
  }

  document.addEventListener('click', onRestockRemoveClick, true);
  document.addEventListener('click', onRestockClick, true);
  document.addEventListener('variant:changed', syncRestockVariant);

  refreshAllButtons();

  window.ZetaRestock = window.ZetaRestock || {};
  window.ZetaRestock.unmarkRequested = unmarkRequested;
  window.ZetaRestock.markRequested = markRequested;
  window.ZetaRestock.isRequested = isRequested;

  log('initialized', {
    apiUrl: cfg().apiUrl,
    resolvedApiUrl: resolveZetaProxyUrl(cfg().apiUrl || ''),
    customerLoggedIn: cfg().customerLoggedIn,
    requestedVariantIds: ensureRequestedIds(),
    debug: debugEnabled()
  });
})();
